import { AbstractDimension, frRccwSelectedDimension } from '@orus.eu/dimensions'
import { type FrRccwQuote, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

export type FrRccwQuoteFailure =
  | { type: 'temporary-wakam-fr-rcc-api-issue'; reason: string }
  | { type: 'unhandled-wakam-fr-rcc-api-error'; reason: string }
  | { type: 'wakam-cannot-provide-price'; reasons: string[] }
export type FrRccwQuoteResult = Result<FrRccwQuote, FrRccwQuoteFailure>

export class FrRccwQuoteDimension<NAME extends string> extends AbstractDimension<NAME, FrRccwQuoteResult> {
  override formatToString(value: FrRccwQuoteResult): string {
    if (value.type === 'failure') {
      return `NULL - ${value.problem.type}`
    }
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const frRccwQuoteDimension = new FrRccwQuoteDimension({
  name: 'frRccwQuote',
  displayKeys: { name: 'dimension_name_fr_rccw_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: {
    lockedInQuoteFor: {
      client: frRccwSelectedDimension,
    },
  },
} as const)
